import React from "react";
import "./style/Breadcrumb.scss";

const Breadcrumb = ({ children, maxWidth = "1120px" }) => {
  return (
    <div id="Breadcrumb">
      <div className="container" style={{ width: "100%", maxWidth }}>
        {children}
      </div>
    </div>
  );
};

export default Breadcrumb;
